import {
  WSCard,
  WSInfoBox,
  WSLoader,
  WSProgressBar
} from "@wingspanhq/fe-component-library";
import { formatNumber } from "accounting";
import React from "react";

interface Props {
  processedRowsCount: number;
  totalRowsCount: number;
}

export const CardReportLoading: React.FC<Props> = ({
  processedRowsCount,
  totalRowsCount
}) => {
  return (
    <WSCard mb="2XL" header="Report is loading">
      <WSProgressBar
        percent={
          totalRowsCount === 0 ? 0 : (processedRowsCount / totalRowsCount) * 100
        }
      />
      <WSInfoBox>
        {totalRowsCount > 0 ? (
          <>
            {formatNumber(processedRowsCount)} of {formatNumber(totalRowsCount)}{" "}
            items loaded and viewable below. Once all items are loaded, the
            report can be downloaded.
          </>
        ) : (
          <WSLoader.Spinner size="S" />
        )}
      </WSInfoBox>
    </WSCard>
  );
};
